import { all, put, takeLatest } from "redux-saga/effects";
import HttpService from "../../../services/HttpService";
import { redirectAuthenticatedRequest } from "../auth/actions";
import { waitTimeout } from "../../../utils";
/**
 *
 * @param {{signupStage: string, idAdjust: string, idInfluencerLink: number, loginData: object }} payload
 */
export function* handleAdjustEvent({ payload }) {
	const { idAdjust, idInfluencerLink, loginData, signupStage } = payload;
	const { billingStatus, investor, multiBroker, cd_access_token, accounts, guardStatus, tradeChat } = loginData;

	try {
		const param = {
			idAdjust,
			signupStage,
			idInfluencerLink,
			idInvestor: investor.id_investor,
			platform: "WEB",
		};

		const resp = yield HttpService.handleAdjustEvent(param);
		localStorage.removeItem("FLUX_INFLUENCER");

		if (!resp.success) throw resp;
	} catch (error) {
		console.error("[ERROR HANDLE_ADJUST_EVENT]", error);
	} finally {
		yield waitTimeout(2000);
		yield put(
			redirectAuthenticatedRequest(
				billingStatus,
				investor,
				multiBroker,
				cd_access_token,
				accounts,
				guardStatus,
				null,
				null,
				null,
				tradeChat
			)
		);
	}
}

export default all([takeLatest("@adjust/HANDLE_ADJUST_EVENT", handleAdjustEvent)]);
